import BaseButton from "../../../components/ui/BaseButton";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { ROLES } from "../../../utils/variables";
import { useState } from "react";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import CompleteProfileModal from "../../WorkJobDetails/CompleteProfileModal";
const ProjectListingHeader = () => {
  const naviagte = useNavigate();
  const { authRole, getPermissionForModule } = useAuth();
  const { hasWriteAccess } = getPermissionForModule("CLIENT_PROJECT");
  const { userData } = useCurrentUser();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  const handleNewProject = () => {
    if (!isProfileCompleted) {
      naviagte("/workBoard/projects/create");
    }
  };

  return (
    <div className="border-b border-zinc-300 bg-white ">
      <BaseWrapper>
        <div className="grid grid-cols-7 gap-y-3 py-[7px] items-center">
          <div className="md:col-span-2 col-span-7">
            <h3 className="font-light md:text-left text-center">
              Project Listing
            </h3>
          </div>
          {authRole !== ROLES.FREELANCE && hasWriteAccess && (
            <div className="md:col-span-5 col-span-7 flex  justify-end">
              <BaseButton
                className="md:w-auto w-full"
                // fullWidth={true}
                variant="contained"
                color="primary"
                style={{
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
                onClick={() => {
                  if (userData?.status !== "APPROVED") {
                    setIsProfileCompleted(true);
                    return;
                  }
                  handleNewProject();
                }}
              >
                Create New Project
              </BaseButton>
            </div>
          )}
        </div>
      </BaseWrapper>
      {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </div>
  );
};

export default ProjectListingHeader;
